import { DsTypography } from '@ice-web-app/designSystem';
import { UsePopoverReturn } from '@ice-web-app/shared-hooks';
import { useZoneStore } from '@ice-web-app/shared-store';
import { Box, ClickAwayListener, Grid, Menu, Stack } from '@mui/material';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type Props = {
  popover: UsePopoverReturn;
};

export const SchoolMenu: FC<Props> = ({ popover }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { schoolZone } = useZoneStore();

  return (
    <ClickAwayListener
      onClickAway={(event) => {
        const target = event.target as Node;

        const anchorElement = typeof popover.anchorEl === 'function' ? popover.anchorEl() : popover.anchorEl;

        if (anchorElement instanceof HTMLElement && !anchorElement.contains(target)) {
          popover.onClose();
        }
      }}
    >
      <Menu
        open={popover.open}
        anchorEl={popover.anchorEl}
        onClick={popover.onClose}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        MenuListProps={{ disablePadding: true }}
        slotProps={{
          paper: {
            sx: {
              width: '652px',
              py: 4,
              mt: 2,
            },
          },
        }}
        hideBackdrop
      >
        <Grid container rowGap={6}>
          {schoolZone?.popupItems?.map((item, index) => {
            const isActive = item.path && location.pathname.includes(item.path);

            return (
              <Grid item justifyItems="center" key={index} sm={2}>
                <Stack
                  spacing={1}
                  sx={{
                    minWidth: '72px',
                    maxWidth: '72px',
                    minHeight: '72px',
                    maxHeight: '72px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 1,
                    cursor: 'pointer',
                    backgroundColor: isActive ? 'primary.50' : 'transparent',
                    '&:hover': { backgroundColor: isActive ? 'primary.50' : 'iceGray.100' },
                  }}
                  onClick={() => {
                    // TODO setCurrentSection must set in the form group main index
                    navigate(item.path);
                  }}
                >
                  <Box
                    sx={{
                      p: 0.75,
                      border: (theme) =>
                        `1px solid ${isActive ? theme.palette.primary[900] : theme.palette.iceGray[200]}`,
                      borderRadius: 2,
                      backgroundColor: (theme) => (isActive ? theme.palette.common.background : 'transparent'),
                    }}
                  >
                    <Box
                      component="img"
                      src={item.icon as string}
                      alt={item.title}
                      sx={{
                        width: '36px',
                      }}
                    />
                  </Box>
                  <DsTypography
                    color={isActive ? 'iceGray.700' : 'iceGray.500'}
                    sx={{
                      fontSize: '10px',
                      lineHeight: '16px',
                      fontWeight: isActive ? 500 : 400,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {item.title}
                  </DsTypography>
                </Stack>
              </Grid>
            );
          })}
        </Grid>
      </Menu>
    </ClickAwayListener>
  );
};
